import React from "react";
import { NavLink } from "react-router-dom";
import { Settings, Package } from "lucide-react";

const SideBarSetting = () => {
  const sidebarStyles = {
    width: "220px",
    minHeight: "calc(90vh - 60px)",
    backgroundColor: "#ffffff",
    padding: "20px 0",
    position: "relative",
    top: 0,
    left: 0,
    boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
    zIndex: 1000,
    border: "1px solid #e9ecef",
    marginLeft: "20px",
    marginTop: "10px",
    borderRadius: "8px",
  };

  const navItemStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start", // Align to left for text
    padding: "12px 20px",
    color: "#495057", // Dark text for white background
    textDecoration: "none",
    transition: "all 0.3s ease",
    position: "relative",
  };

  const activeStyles = {
    backgroundColor: "#007bff",
    color: "#ffffff",
  };

  const iconStyles = {
    fontSize: "20px",
    marginRight: "12px", // Space between icon and text
    minWidth: "20px", // Prevent icon from shrinking
  };

  return (
    <div style={sidebarStyles}>
      <div className="sidebar-content">
        <h4
          style={{
            color: "#495057",
            padding: "0 20px",
            marginBottom: "20px",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Settings
        </h4>

        <nav>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            <li>
              <NavLink
                end
                to="/setting"
                style={({ isActive }) => ({
                  ...navItemStyles,
                  ...(isActive ? activeStyles : {}),
                })}
                className="settings-nav-link"
              >
                <Settings size={20} style={iconStyles} />
                Refund
              </NavLink>
            </li>

            {/* <li>
              <NavLink
              end
                to="/setting/stock"
                style={({ isActive }) => ({
                  ...navItemStyles,
                  ...(isActive ? activeStyles : {}),
                })}
                className="settings-nav-link"
              >
                <Package size={20} style={iconStyles} />
                Stock
              </NavLink>
            </li> */}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default SideBarSetting;
